<template>
  <div>
    <h3 class="title-text">公司资质</h3>
    <p>{{$t(`about.company_qualification_1`)}}</p>
    <p>{{$t(`about.company_qualification_2`)}}</p>
  </div>
</template>

<script>
    export default {
        name: '',
        data () {
            return {
              txt1:'丁丁云康信息科技有限公司成立2016年，是一家专注于健康管理信息服务的高新技术企业。公司主要从事健康促进管理领域的信息技术研发，跨界整合云架构移动互联网技术和健康管理专业资源，以智能健康管理大数据平台为核心，借助移动互联网、IOT技术实现端到端的解决方案，协助各类机构、企业的健康管理部门延伸服务范围、完善服务质量、提升服务效率，同时帮助个人用户实现日常的健康自我管理与数据跟踪踪、分析。“丁丁云康”愿通过自己的努力成为每个人的贴身健康管家，使健康自我管理与促进成为大家每日生活中随时、随地可以轻松实现的工作，不再复杂、繁重。',
              txt2:'公司团队由资深信息技术专家和经验丰富的健康顾问组成，丁丁云康健康管理平台成功地为医疗机构、体检机构、社康中心、健管中心等单位提供健康管理的信息技术服务与支持。丁丁云康信息科技坚持技术持续创新、服务以人为本、不断为客户创造价值的发展理念，希望借助人工智能、大数据及移动互联网的发展使更多的用户可以关注自身健康、更容易地实现自我健康管理与促进、更好地享受健康生活。',
              txt3:'丁丁云康信息科技坚持技术持续创新、服务以人为本、不断为客户创造价值的发展理念，希望借助人工智能、大数据及移动互联网的发展使更多的用户可以关注自身健康、更容易地实现自我健康管理与促进、更好地享受健康生活。'
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// aqualification.vue?02afb0ad